
import { ApiURLs } from "../../../constant/ApiUrls";
import { deleteData, fetchData, updateData, } from "../../../services/api";





export const updaqteContactUs = (data, page = 1, pageSize = 10, keyword = '', priority = null, status = null) => {
  return async (dispatch) => {
    dispatch({ type: "ADD_CONTACT_US_REQUEST" });

    try {
      const dealerResponse = await updateData(data, `${ApiURLs.CONTACTUS}/${data.id}`);


      if (dealerResponse.status === 1) {
        dispatch({ type: "ADD_CONTACT_US_SUCCESS" });
        dispatch(contactUsLisitingRequest(page, pageSize, keyword, priority, status));
        return true;
      } else {
        dispatch({ type: "ADD_CONTACT_US_FAILED" });
        return false;
      }
    } catch (error) {
      console.error("Add Dealer Error:", error);
      dispatch({ type: "ADD_CONTACT_US_FAILED" });
      return false;
    }
  };
};


export const contactUsLisitingRequest = (page = 1, pageSize = 50, keyword = '', priority = null, status = null) => {

  return async (dispatch) => {


        const params = new URLSearchParams();

    params.append("offset", page);
    params.append("limit", pageSize);

    if (keyword && keyword.trim() !== "") {
      params.append("keyword", keyword);
    }

    if (priority !== null && priority !== "") {
      params.append("priority", priority);
    }

    if (status !== null && status !== "") {
      params.append("status", status);
    }


        params.append("type", "contact_us");

        
    const url = `${ApiURLs.CONTACTUS}?${params.toString()}`;



    console.log('CHECK:::::::', url, pageSize);
    // wait untill the data not received so getData function take data and url part
    dispatch({ "type": "GET_CONTACT_US_REQUEST" });
    try {
      var contactUsData = await fetchData(url);
      console.log(`response when we try to get contact us  ${JSON.stringify(contactUsData)}`)
      if (contactUsData.status === 1) {
        dispatch({ "type": "GET_CONTACT_US_REQUEST_SUCCESS", "payload": contactUsData.data.result, "total": contactUsData.data.total });

      } else {
        dispatch({ "type": "GET_CONTACT_US_REQUEST_FAILED" });
      }
    } catch (error) {
      dispatch({ "type": "GET_CONTACT_US_REQUEST_FAILED" });
      console.log(`error while try to get contact us ${error}`)
    }
  }
};



export const deleteContactUs = (id, page = 1, pageSize = 10, keyword = '', priority = null, status = null) => {
  return async (dispatch) => {

    // dispatch();
    dispatch({ "type": "DELETE_CONTACT_US_REQUEST" });
    try {


      var contactUsResponse = await deleteData(`${ApiURLs.CONTACTUS}/${id}`);
      if (contactUsResponse.status === 1) {
        dispatch({ "type": "ADD_CONTACT_US_SUCCESS" });
        dispatch(contactUsLisitingRequest(page, pageSize, keyword, priority, status));
      } else {
        dispatch({ "type": "ADD_CONTACT_US_FAILED" });
      }
    } catch (error) {
      dispatch({ "type": "ADD_CONTACT_US_FAILED" });

    }
  };
};


